export const APP_PREFIX = '/app'
export const IMPERSONATE_PATH = '/impersonate'
export const REPORTING_DASHBOARD_SLUG = 'dashboard'
export const REPORTING_AI_SLUG = 'ai'

const routes = {
  app: {
    error: `${APP_PREFIX}/error`,
    login: `${APP_PREFIX}/login`,
    logout: `${APP_PREFIX}/logout`,
    selectAccount: `${APP_PREFIX}/select-account`,
    home: `${APP_PREFIX}/home`,
    route: `${APP_PREFIX}/route`,
    exportRouteWorkOrders: `${APP_PREFIX}/routes/:routeId/work_orders/export`,
    exportRouteWorkOrder: `${APP_PREFIX}/routes/:routeId/work_orders/:workOrderId/export`,
    routes: `${APP_PREFIX}/routes`,
    masterSequence: `${APP_PREFIX}/master-sequence`,
    payments: `${APP_PREFIX}/billing/payments`,
    createInvoices: `${APP_PREFIX}/billing/create_invoices`,
    createManualInvoices: `${APP_PREFIX}/billing/create_manual_invoices`,
    accountsReceivable: `${APP_PREFIX}/billing/accounts_receivable`,
    invoices: `${APP_PREFIX}/billing/invoices`,
    invoiceGroups: `${APP_PREFIX}/billing/invoice_groups`,
    paymentGroups: `${APP_PREFIX}/billing/payment_groups`,
    paymentBatches: `${APP_PREFIX}/billing/payment_batches`,
    paymentBatchDetail: `${APP_PREFIX}/billing/payment_batches/:id`,
    billing: `${APP_PREFIX}/billing`,
    reports: `${APP_PREFIX}/reports`,
    reportDetails: `${APP_PREFIX}/reports/:slug`,
    reporting: `${APP_PREFIX}/reporting`,
    reportingDashboard: `${APP_PREFIX}/reporting/${REPORTING_DASHBOARD_SLUG}`,
    aiReports: `${APP_PREFIX}/reporting/${REPORTING_AI_SLUG}`,
    reportingDetails: `${APP_PREFIX}/reporting/:id`,
    pricing: `${APP_PREFIX}/pricing`,
    pricingServices: `${APP_PREFIX}/pricing/services`,
    pricingFees: `${APP_PREFIX}/pricing/general_fees`,
    pricingLateFees: `${APP_PREFIX}/pricing/late_fees`,
    pricingLateFeeDetails: `${APP_PREFIX}/pricing/late_fees/:id`,
    pricingRentalFees: `${APP_PREFIX}/pricing/rental_fees`,
    pricingRentalFeeDetails: `${APP_PREFIX}/pricing/rental_fees/:id`,
    pricingDisposalFees: `${APP_PREFIX}/pricing/disposal_fees`,
    pricingDisposalFeeDetails: `${APP_PREFIX}/pricing/disposal_fees/:id`,
    pricingTaxes: `${APP_PREFIX}/pricing/taxes`,
    pricingTaxesNew: `${APP_PREFIX}/pricing/taxes_new`,
    pricingTaxDetail: `${APP_PREFIX}/pricing/taxes_new/:id`,
    pricingZones: `${APP_PREFIX}/pricing/zones`,
    pricingZoneDetail: `${APP_PREFIX}/pricing/zones/:id`,
    // Pre-rename URLs. Kept as redirect sources so bookmarked links keep working.
    pricingTaxZones: `${APP_PREFIX}/pricing/tax_zones`,
    pricingTaxZoneDetail: `${APP_PREFIX}/pricing/tax_zones/:id`,
    pricingServiceGroups: `${APP_PREFIX}/pricing/service_groups`,
    configuredServiceDetails: `${APP_PREFIX}/configured-service/:id`,
    followUp: `${APP_PREFIX}/follow-up`,
    dashboard: `${APP_PREFIX}/dashboard`,
    customers: `${APP_PREFIX}/customers`,
    accounts: `${APP_PREFIX}/customers/accounts`,
    locations: `${APP_PREFIX}/customers/locations`,
    recentlyViewed: `${APP_PREFIX}/customers/recently_viewed`,
    recentlyAdded: `${APP_PREFIX}/customers/recently_added`,
    customerDetails: `${APP_PREFIX}/customers/:accountId/details`,
    accountGroups: `${APP_PREFIX}/customers/account_groups`,
    newCustomerList: `${APP_PREFIX}/customers/account_groups/new`,
    customerListDetails: `${APP_PREFIX}/customers/account_groups/lists/:customerListId`,
    suspensionGroups: `${APP_PREFIX}/customers/suspension_groups`,
    suspendedAccounts: `${APP_PREFIX}/customers/suspension_groups/suspended`,
    workOrderDetails: `${APP_PREFIX}/work-orders/:workOrderId/details`,
    workOrdersReview: `${APP_PREFIX}/billing/work_orders_review`,
    workOrdersReviewV2: `${APP_PREFIX}/billing/work_orders_review_v2`,
    lateFeeReview: `${APP_PREFIX}/billing/late_fee_review`,
    disposalTickets: `${APP_PREFIX}/billing/disposal_tickets_review`,
    search: `${APP_PREFIX}/search`,
    searchDetails: `${APP_PREFIX}/search/:slug`,
    settings: `${APP_PREFIX}/settings`,
    settingDetails: `${APP_PREFIX}/settings/:slug`,
    help: `${APP_PREFIX}/help`,
    notifications: `${APP_PREFIX}/notifications`,
    inventory: `${APP_PREFIX}/inventory`,
    inventoryContainers: `${APP_PREFIX}/inventory/containers`,
    inventoryContainersMoves: `${APP_PREFIX}/inventory/containers/moves`,
    inventoryContainerStatus: `${APP_PREFIX}/inventory/containers/status`,
    inventoryContainerYard: `${APP_PREFIX}/inventory/containers/yard`,
    importContainers: `${APP_PREFIX}/inventory/containers/import`,
    addContainer: `${APP_PREFIX}/inventory/containers/add`,
    editContainer: `${APP_PREFIX}/inventory/containers/edit`,
    messaging: `${APP_PREFIX}/messaging`,
    messagingNewMessage: `${APP_PREFIX}/messaging/new`,
    messagingDetail: `${APP_PREFIX}/messaging/:messageId`,
    visionExceptions: `${APP_PREFIX}/vision-exceptions`,
    visionExceptionsDetails: `${APP_PREFIX}/vision-exceptions/:slug`,
  },
}

export default routes

export const getWorkOrderDetailsPageUrl = (workOrderId: string): string => `${APP_PREFIX}/work-orders/${workOrderId}/details`
export const getCustomerDetailsPageUrl = (accountId: string): string => `${APP_PREFIX}/customers/${accountId}/details`
export const getLateFeeDetailsPageUrl = (id: string): string => `${APP_PREFIX}/pricing/late_fees/${id}`
export const getRentalFeeDetailsPageUrl = (id: string): string => `${APP_PREFIX}/pricing/rental_fees/${id}`
export const getDisposalFeeDetailsPageUrl = (id: string): string => `${APP_PREFIX}/pricing/disposal_fees/${id}`
export const getConfiguredServiceDetailsPageUrl = (id: string): string => `${APP_PREFIX}/configured-service/${id}`
export const getMessageDetailPageUrl = (messageId: string): string => `${APP_PREFIX}/messaging/${messageId}`
export const NEW_MESSAGE_PREFILL_PARAM = { LIST: 'customerListId', GROUP: 'accountGroupId' } as const

export const getNewMessageUrl = (prefill: typeof NEW_MESSAGE_PREFILL_PARAM[keyof typeof NEW_MESSAGE_PREFILL_PARAM], id: string): string =>
  `${APP_PREFIX}/messaging/new?${prefill}=${encodeURIComponent(id)}`
export const getCustomerListDetailsPageUrl = (customerListId: string): string =>
  `${APP_PREFIX}/customers/account_groups/lists/${customerListId}`
export const getTaxDetailPageUrl = (id: string) => `${APP_PREFIX}/pricing/taxes_new/${id}`
export const getZoneDetailPageUrl = (id: string) => `${APP_PREFIX}/pricing/zones/${id}`
export const getVisionExceptionsTabUrl = (slug: string): string => `${APP_PREFIX}/vision-exceptions/${slug}`

// Temporary fix, until we remove dispatch(getCustomerDetails({ accountId })) and use RTK invalidateTags
export const isCustomerDetailsPage = () => {
  const { pathname } = window.location

  return pathname.includes(`${APP_PREFIX}/customers`) && pathname.includes('/details')
}

const { app } = routes
const { login, selectAccount } = app

export const isPublicURL = (route: string): boolean => [login, selectAccount].includes(route)

export const getMasterSequencePageUrl = (routeId: string, optimizationJobId?: string, dayOfWeek?: string): string => {
  const params = new URLSearchParams({ route_id: routeId })
  // Without the day the board opens on whichever one it defaults to, and the job's column is absent.
  if (dayOfWeek) params.set('day_of_week', dayOfWeek)
  if (optimizationJobId) params.set('optimization_job', optimizationJobId)
  return `${routes.app.masterSequence}?${params.toString()}`
}
